import { OcpsStoreState } from '../store/schema/OcpsPolicyStore';
import getOcpsPolicyStoreState from '../selectors/getOcpsPolicyStoreState';
import { shouldRetryFetchPoliciesAndSetStore } from './shouldRetryFetchPoliciesAndSetStore';
import { tryGetGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';
import { logUsageFromAccounts } from 'owa-account-analytics';

export default function isOcpsStoreReady(): boolean {
    const storeState = getOcpsPolicyStoreState();
    const isStoreReady =
        storeState === OcpsStoreState.Ready || storeState === OcpsStoreState.FailedRetry;

    if (storeState === OcpsStoreState.FailedRetry) {
        shouldRetryFetchPoliciesAndSetStore();

        logUsageFromAccounts('OcpsStoreFetchRetry', tryGetGlobalSettingsAccountMailboxInfo());
    }

    return isStoreReady;
}
